import { CmsObjectWithDefault } from '@components/Cms/types';

export type MfaPanelCmsKey =
    | 'MfaTitle'
    | 'MfaHeader'
    | 'ConfirmIdentitySinglePhone'
    | 'ConfirmIdentityMultiplePhone'
    | 'CodeVerificationComfirmation'
    | 'SelectPhone'
    | 'ReceiveCodeQuestion'
    | 'TextMessage'
    | 'PhoneCall'
    | 'SendCode'
    | 'SendNewCode'
    | 'SubmitCode'
    | 'GoBack'
    | 'InputLabel'
    | 'CodeExpiresInMinuteSeconds'
    | 'CodeExpiresInMinutesSeconds'
    | 'CodeExpiresInMinutesSecond'
    | 'CodeExpiresInMinuteSecond'
    | 'RequiredField'
    | 'CodeExpired'
    | 'VerificationCode'
    | 'SomethingWrong'
    | 'OtpIncorrect'
    | 'GoBackAria'
    | 'SendNewCodeAria'
    | 'ConsentBoxHeader'
    | 'ConsentBoxBody'
    | 'MfaPageTitle1'
    | 'MfaPageTitle2';

export const MfaPanelCmsWithDefault: CmsObjectWithDefault<MfaPanelCmsKey> = {
    MfaTitle: {
        cmsId: 238382,
        defaultTranslation: 'Citi Travel - Account Verification',
    },
    MfaHeader: {
        cmsId: 158238,
        defaultTranslation: 'Verify your account to continue.',
    },
    ConfirmIdentitySinglePhone: {
        cmsId: 158239,
        defaultTranslation:
            "For your security, please confirm your identity. We'll send a verification code to your number on file: {0}",
    },
    ConfirmIdentityMultiplePhone: {
        cmsId: 158240,
        defaultTranslation: 'For your security, please confirm your identity.',
    },
    CodeVerificationComfirmation: {
        cmsId: 158368,
        defaultTranslation: 'Please verify your account by entering the code sent to {0}',
    },
    SelectPhone: {
        cmsId: 158241,
        defaultTranslation: 'Select a phone number:',
    },
    ReceiveCodeQuestion: {
        cmsId: 158242,
        defaultTranslation: 'How would you like to receive your code?',
    },
    TextMessage: {
        cmsId: 158243,
        defaultTranslation: 'Text message',
    },
    PhoneCall: {
        cmsId: 158244,
        defaultTranslation: 'Phone call',
    },
    SendCode: {
        cmsId: 158245,
        defaultTranslation: 'Send verification code',
    },
    SendNewCode: {
        cmsId: 158246,
        defaultTranslation: 'Send a new code',
    },
    SubmitCode: {
        cmsId: 158247,
        defaultTranslation: 'Submit code',
    },
    GoBack: {
        cmsId: 158248,
        defaultTranslation: 'Go back',
    },
    InputLabel: {
        cmsId: 238385,
        defaultTranslation: 'Please input the verification code received',
    },
    CodeExpiresInMinuteSeconds: {
        cmsId: 158249,
        defaultTranslation: 'Your code expires in {0} minute, {1} seconds.',
    },
    CodeExpiresInMinutesSeconds: {
        cmsId: 158250,
        defaultTranslation: 'Your code expires in {0} minutes, {1} seconds.',
    },
    CodeExpiresInMinutesSecond: {
        cmsId: 158251,
        defaultTranslation: 'Your code expires in {0} minutes, {1} second.',
    },
    CodeExpiresInMinuteSecond: {
        cmsId: 158252,
        defaultTranslation: 'Your code expires in {0} minute, {1} second.',
    },
    RequiredField: {
        cmsId: 158253,
        defaultTranslation: 'Required field',
    },
    CodeExpired: {
        cmsId: 158254,
        defaultTranslation: 'Your code has expired.',
    },
    VerificationCode: {
        cmsId: 158255,
        defaultTranslation: 'Verification code:',
    },
    SomethingWrong: {
        cmsId: 176897,
        defaultTranslation: 'Sorry, something went wrong. Please try again later.',
    },
    OtpIncorrect: {
        cmsId: 176888,
        defaultTranslation: 'That code was incorrect. Please try again.',
    },
    GoBackAria: {
        cmsId: 238387,
        defaultTranslation: 'Go back to previous page',
    },
    SendNewCodeAria: {
        cmsId: 238386,
        defaultTranslation: 'Send a new verification code to the same phone',
    },
    ConsentBoxHeader: {
        cmsId: 250655,
        defaultTranslation: 'Important',
    },
    ConsentBoxBody: {
        cmsId: 250656,
        defaultTranslation:
            'By clicking Send verification code below I agree to receive a call, prerecorded message or text message from an automated dialing system at the number above to receive my Identification Code. Normal cell phone charges may apply.',
    },
    MfaPageTitle1: {
        cmsId: 238382,
        defaultTranslation: 'Citi Travel - Account Verification',
    },
    MfaPageTitle2: {
        cmsId: 238383,
        defaultTranslation: 'Citi Travel - Authentication',
    },
};
